import './new-coupon.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormCoupon from "../form-coupon/form-coupon";
import { useNewCoupon } from './new-coupon.hook';

export function NewCoupon() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewCoupon();

  return (
    <div id="NewCoupon" className="coupon">
      <HeaderContent
        title={<h1>New Coupon</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormCoupon />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewCoupon;